import packingTypes from './packingTypes'
import saleTypes from './saleTypes'
import targetMarkets from './targetMarkets'
import transportTypes from './transportTypes'
import plantingMedia from './plantingMedium'
import plantingTypes from './plantingTypes'
import phases from './phase'
import farms from './farms'
import nurseries from './nurseries'
import varieties from './varieties'
import packhouseBlocks from './packhouseBlocks'
import farmSupplierCodes from './farmSupplierCodes'
import disposalReasons from './disposalReasons'
import countries from './countries'
import licenseHolders from './licenseHolders'
import licensors from './licensors'
import subLicenseHolders from './subLicenseHolders'
import breeders from './breeders'
import commodities from './commodities'
import regions from './regions'
import adjustmentEventTypes from './adjustmentEventTypes'

export default function masterData(instance) {
	return {
		packingTypes: packingTypes(instance),
		saleTypes: saleTypes(instance),
		transportTypes: transportTypes(instance),
		targetMarkets: targetMarkets(instance),
		plantingTypes: plantingTypes(instance),
		plantingMedia: plantingMedia(instance),
		commodities: commodities(instance),
		phases: phases(instance),
		farms: farms(instance),
		regions: regions(instance),
		farmSupplierCodes: farmSupplierCodes(instance),
		nurseries: nurseries(instance),
		varieties: varieties(instance),
		packhouseBlocks: packhouseBlocks(instance),
		disposalReasons: disposalReasons(instance),
		countries: countries(instance),
		licenseHolders: licenseHolders(instance),
		licensors: licensors(instance),
		breeders: breeders(instance),
		subLicenseHolders: subLicenseHolders(instance),
		adjustmentEventTypes: adjustmentEventTypes(instance)
	}
}
